import { render, staticRenderFns } from "./TeacherNavbar.vue?vue&type=template&id=e66937ca"
import script from "./TeacherNavbar.vue?vue&type=script&lang=js"
export * from "./TeacherNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports